import styles from "./tos.module.css";

function TOS() {
  return (
    <div className={styles.tos}>
      <div className={styles.card}>
        <h1>Terms of Service</h1>
        <p>
          Steedie reserves the right to add or remove Steedie Tokens from your
          account at its sole discretion, for any reason.
        </p>
        <p>
          You acknowledge that you are not entitled to any compensation in the
          event that the Steedie Ads service is terminated.
        </p>
        <p>
          Refunds are not guaranteed and will only be provided at Steedie's
          discretion.
        </p>
        <p>
          Ads submitted to the platform are subject to an approval process. Ads
          will only be displayed on the network once approved by Steedie (the
          system handles this automatically).
        </p>
        <p>
          Steedie reserves the right to terminate or suspend accounts that
          violate these terms, or for any other reason, at its sole discretion.
        </p>
        <p>
          Steedie makes no warranties regarding the reliability or accuracy of
          its services. Use our services at your own risk.
        </p>
        <p>
          Steedie reserves the right to change these terms at any time. Changes
          will take effect upon posting.
        </p>
        <p>
          You agree to indemnify and hold harmless Steedie from any and all
          claims, losses, damages, or other liabilities arising from your use of
          the service.
        </p>
      </div>
    </div>
  );
}

export default TOS;
